export const DESCRIZIONEALLERGENI = {
  fCereali: "CEREALI E DERIVATI",
  fCrostacei: "CROSTACEI E DERIVATI",
  fUova: "UOVA E DERIVATI",
  fPesce: "PESCE E DERIVATI",
  fArachidi: "ARACHIDI E DERIVATI",
  fSoia: "SOIA E DERIVATI",
  fSesamo: "SESAMO E DERIVATI",
  fLatte: "LATTE E DERIVATI",
  fGuscio: "FRUTTA A GUSCIO",
  fSedano: "SEDANO E DERIVATI",
  fSenape: "SENAPE E DERIVATI",
  fSolfiti: "ANIDRIDE SOLFOROSA E SOLFITI",
  fLupino: "LUPINO E PRODOTTI A BASE DI",
  fMolluschi: "MOLLUSCHI E PRODOTTI A BASE DI",
};
